import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterLabel = ({ number, label, testid }) => (
  <div className="flex items-baseline gap-4 mb-8" data-testid={testid}>
    <span className="font-heading text-5xl sm:text-6xl font-bold text-brand/20 leading-none">{number}</span>
    <span className="text-xs tracking-[0.3em] uppercase font-bold text-slate-500">{label}</span>
    <span className="flex-1 h-px bg-slate-200 self-center" />
  </div>
);
